import React from "react"
import { TextStyle, Pressable } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { Button, Text, IconFont, BetweenFlex, CenterFlex, StartFlex } from "~components/El"
import { HeaderProps } from "./header.props"

const TITLE: TextStyle = { textAlign: "center", color: "#121212" }

/**
 * Header that appears on many screens. Will hold navigation buttons and screen title.
 */
export function Header(props: HeaderProps) {
  const {
    onLeftPress,
    onRightPress,
    rightIcon,
    headerRight,
    leftIcon = "left",
    headerLeft,
    headerText,
    style,
    titleStyle,
  } = props
  const theme = useTheme()
  const header = headerText || ""
  return (
    <BetweenFlex
      width="100%"
      paddingTop="24px"
      paddingBottom="24px"
      paddingRight="16px"
      bg={theme.colors.blockBackground}
      style={style}
    >
      <StartFlex width="32px" minWidth="32px">
        {leftIcon ? (
          <Pressable onClick={onLeftPress} style={{ paddingLeft: 12 }}>
            <IconFont name={leftIcon} color={theme.colors.secondary} size={16} />
          </Pressable>
        ) : (
          headerLeft ?? null
        )}
      </StartFlex>
      <CenterFlex flex={1}>
        <Text style={[TITLE, titleStyle]} fontSize="16px" fontWeight="600">
          {header}
        </Text>
      </CenterFlex>
      <StartFlex width="auto" minWidth="32px" justifyContent="flex-end">
        {rightIcon ? (
          <Button preset="link" onClick={onRightPress}>
            <IconFont name={rightIcon} color="#aaa" size={30} />
          </Button>
        ) : (
          headerRight ?? null
        )}
      </StartFlex>
    </BetweenFlex>
  )
}
